import React from 'react';
import './AiDisclaimer.css';

interface AiDisclaimerProps {
  onAccept: () => void;
}

export const AiDisclaimer: React.FC<AiDisclaimerProps> = ({ onAccept }) => (
  <div className="disclaimer-overlay">
    <div className="disclaimer-modal">
      <div className="disclaimer-icon">🤖</div>
      <h2>AI-Generated Content</h2>
      <p>
        Brain Break Cards uses artificial intelligence to generate educational prompts.
        While we apply multiple layers of safeguards — including content filters, safety
        guardrails, and human review — <strong>AI-generated content may occasionally
        contain errors or inappropriate material.</strong>
      </p>
      <p>
        It is important that a teacher or parent reviews the content for appropriateness
        before sharing it with children. You can flag any card for review using the
        🚩 button.
      </p>
      <button className="disclaimer-accept" onClick={onAccept}>
        I understand — continue
      </button>
    </div>
  </div>
);
